export var Role;
(function (Role) {
    Role["system_admin"] = "org:system_admin";
    Role["admin"] = "org:admin";
    Role["manager"] = "org:manager";
    Role["employee"] = "org:employee";
})(Role || (Role = {}));
export var Actions;
(function (Actions) {
    Actions["delete"] = "delete";
    Actions["read"] = "read";
    Actions["create"] = "create";
    Actions["update"] = "update";
})(Actions || (Actions = {}));
export var Resource;
(function (Resource) {
    Resource["interactions"] = "interactions";
    Resource["issues"] = "issues";
    Resource["kci"] = "kci";
    Resource["company"] = "company";
    Resource["employees"] = "employees";
    Resource["values"] = "values";
    Resource["one_on_one"] = "one_on_one";
    Resource["team"] = "team";
    Resource["lessons"] = "lessons";
    Resource["integrations"] = "integrations";
    Resource["gaps"] = "gaps";
})(Resource || (Resource = {}));
